import React, { useEffect, useState } from 'react'
import { Col, Form, Modal, Row } from 'react-bootstrap'
import CloseSharpIcon from '@mui/icons-material/CloseSharp';
import { customStyles } from '../../selectStyles';
import Flatpickr from "react-flatpickr";
import { useDispatch, useSelector } from 'react-redux';
import { fetchCityData } from '../../redux/actions/citiesAction';
import ReactSelect from "react-select";



const CareerGap = ({ showCareer, handleCloseCareer }) => {

    const [display, setDisplay] = useState(false)
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [type, setType] = useState("Education"); // Default to Education

    const [isPresent, setIsPresent] = useState(false);
    const [description, setDescription] = useState("");
    const [profileHeadline, setProfileHeadline] = useState("");

    const dispatch = useDispatch();

    //   Get City
    const [citySearch, setCitySearch] = useState(null);
    const { cityList, selectedcityId } = useSelector((state) => state.cities);

    useEffect(() => {
        dispatch(fetchCityData());
    }, [dispatch]);
    const handleCityInputChange = (inputValue) => {
        dispatch(fetchCityData(inputValue));
    };

    const handleCity = (selectedOption) => {
        if (selectedOption) {
            // dispatch(selectCity(selectedOption.value));
            setCitySearch(selectedOption.value);
        } else {
            setCitySearch(null);
        }
    };

    return (
        <>
            <Modal show={showCareer} onHide={handleCloseCareer} centered size="md">
                <Modal.Header >
                    <Modal.Title>Career Gap</Modal.Title>
                    <CloseSharpIcon className="pointer" onClick={handleCloseCareer} />
                </Modal.Header>

                <Modal.Body className="settings">
                    <Row>
                        <Col md={12} className="d-flex align-items-center">
                            <Form.Check
                                type="radio"
                                label="Education"
                                name="type"
                                id="education"
                                className="me-4"
                                checked={type === "Education"}
                                onChange={() => setType("Education")}
                            />
                            <Form.Check
                                type="radio"
                                label="Experience"
                                name="type"
                                id="experience"
                                checked={type === "Experience"}
                                onChange={() => setType("Experience")}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <Form.Group controlId="city">
                                <Form.Label className="class-type">
                                    City
                                    <span style={{ color: "red" }} className="ms-2">
                                        *
                                    </span>
                                </Form.Label>
                            </Form.Group>
                            <div className="post-form-group mb-0">
                                <ReactSelect
                                    options={cityList}
                                    onChange={handleCity}
                                    value={cityList.find((option) => option.value === citySearch) || null}
                                    onInputChange={handleCityInputChange}
                                    placeholder="Search & Select City"
                                    classNamePrefix="react-select"
                                    className="form-control"
                                    styles={customStyles}
                                    isClearable
                                />
                            </div>
                            {display && !citySearch ? (
                                <span className="error_msg_lbl">Search & Select City </span>
                            ) : null}
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12} className="d-flex align-items-center mt-4">
                            <Form.Check
                                type="checkbox"
                                label="Is Present"
                                checked={isPresent}
                                onChange={(e) => setIsPresent(e.target.checked)}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6} className="mb-0 mt-2">
                            <Form.Group controlId="startYear">
                                <Form.Label className="class-type">Start Year</Form.Label>
                                <Flatpickr
                                    value={startDate}
                                    className="custom-style"
                                    onChange={(date) => setStartDate(date[0])}
                                    placeholder="Enter Start Year"
                                    options={{
                                        maxDate: new Date(), // Disable future dates
                                    }}
                                    disabled={isPresent} // Disables input if "Is Present" is checked
                                />
                            </Form.Group>
                            {display && !startDate ? (
                                <span className="error_msg_lbl">Enter Start Year</span>
                            ) : null}
                        </Col>
                        <Col md={6} className="mb-2 mt-2">
                            <Form.Group controlId="endYear">
                                <Form.Label className="class-type">End Year</Form.Label>
                                <Flatpickr
                                    value={endDate}
                                    onChange={(date) => setEndDate(date[0])}
                                    placeholder="Enter End Year"
                                    disabled={isPresent} // Disables input if "Is Present" is checked
                                    className="custom-style"
                                    options={{
                                        minDate: startDate || null,
                                    }}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className='mt-2'>
                        <Col md={12}>
                            <Form.Group controlId="profileHeadline  ">
                                <Form.Label className="class-type">Profile Headline</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={profileHeadline}
                                    className="custom-style Dark-Input-from-group"
                                    onChange={(e) => setProfileHeadline(e.target.value)}
                                    placeholder="Enter Profile Headline"
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className='mt-2'>
                        <Col md={12}>
                            <Form.Group controlId="description  ">
                                <Form.Label className="class-type">Description</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={3}
                                    value={description}
                                    className="custom-style Dark-Input-from-group"
                                    onChange={(e) => setDescription(e.target.value)}
                                    placeholder="Enter Description"
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <div className="d-flex justify-content-end mt-4">
                        <div className="add-class-submit-button mt-4 d-flex justify-content-center">
                            <div className="khojPrimaryBtn ms-3">
                                <a href="#/" className="">
                                    Save
                                </a>
                            </div>
                        </div>
                    </div>
                </Modal.Body>



            </Modal>
        </>
    )
}

export default CareerGap